import { PageTitle } from "../../components/PageTitle";
import { useOrganizationContext } from "../../contexts/organizations/organizationsContext";
import { useApplications } from "../../hooks/reactQueryHooks/useApplications";
import { OverviewPage } from "./components/OverviewPage";

const OverviewWrapper = () => {
  const { currentOrganization } = useOrganizationContext();
  const { data, isLoading, isFetching } = useApplications(
    currentOrganization?.id || "",
  );
  return (
    <>
      {currentOrganization && (
        <>
          <div className="d-flex align-items-center no-breadcrumbs">
            <PageTitle pageTitle="Overview" />
          </div>
          <OverviewPage
            applications={isLoading || isFetching ? undefined : data}
          />
        </>
      )}
    </>
  );
};

export { OverviewWrapper };
